import React from 'react';
import { Heart, Zap, Shield } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white/10 backdrop-blur-md border-t border-white/20 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex items-center space-x-3">
            <div className="bg-gradient-to-r from-red-500 to-pink-500 p-2 rounded-lg">
              <Heart className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 dark:text-white">Health First</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                Personalized plans based on your health data
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <div className="bg-gradient-to-r from-yellow-500 to-orange-500 p-2 rounded-lg">
              <Zap className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 dark:text-white">AI Powered</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                Advanced AI creates optimal workout plans
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <div className="bg-gradient-to-r from-green-500 to-teal-500 p-2 rounded-lg">
              <Shield className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 dark:text-white">Secure & Private</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                Your data is encrypted and protected
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-white/20 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-300">
            © 2025 AI Fitness Planner. Built with AWS, React, and ❤️
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
